<template>
  <fragment>
    <div :class="['file-input-contents', {'with--padding' : isWithPadding}]">
      <article v-for="(image, i) in showImages" :key="i" class="file-input file-input-content">
        <img :src="image.url" alt="" class="file-input-image">
        <v-btn v-if="isShowRemoveButton" class="file-input__remove-button" fab dark x-small color="secondary" @click="deleteImage(i)">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
      </article>
      <div class="file-input-box file-input-content">
        <label :for="`file${index}`" class="file-input__label">추가하려면 클릭</label>
        <input type="file" :id="`file${index}`" class="file-input__input" @change="addImage($event.target.files[0])">
      </div>
    </div>
  </fragment>
</template>

<script>
import { image } from '@/api'
import '@/assets/style/vendors/swiper.4.5.0.min.css'
export default {
  components: {
  },
  props: {
    imageObject: {
      type: Object,
      default: () => {
        return {
          images: [],
          deleteTarget: [],
          addTarget: []
        }
      }
    },
    index: {
      type: Number,
      default: () => -1
    },
    isWithPadding: {
      type: Boolean,
      default: () => false
    },
    isShowRemoveButton: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      showImages: [],
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  async created () {
    for (const i in this.imageObject.images) {
      this.pushImageFromData(image.getUrl(this.imageObject.images[i]))
    }
  },
  methods: {
    addImage (file) {
      if (!file.type.match('image/*')) {
        alert('이미지 파일만 등록할 수 있습니다.')
        return
      }
      const url = this.pushImageFromFile(file)
      this.imageObject.addTarget.push({ file, url })
      this.emitImageObject()
    },
    deleteImage (index) {
      const target = this.showImages[index]
      if (target.type === 'present') {
        this.imageObject.deleteTarget.push(target.name)
      }
      if (target.type === 'new') {
        const addTargetIndex = this.imageObject.addTarget.findIndex(x => x.url === target.url)
        this.imageObject.addTarget.splice(addTargetIndex, 1)
      }
      this.emitImageObject()
      this.showImages.splice(index, 1)
    },
    pushImageFromData (data) {
      this.showImages.push({ type: 'present', name: data, url: data })
      return data
    },
    pushImageFromFile (file) {
      const url = URL.createObjectURL(file)
      this.showImages.push({ type: 'new', url })
      return url
    },
    emitImageObject () {
      this.$emit('update:imageObject', this.imageObject)
    },
    decodeBase64 (data) {
      const byteCharacters = atob(data)
      const byteNumbers = new Array(byteCharacters.length)
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      return new Uint8Array(byteNumbers)
    }
  }
}
</script>

<style lang="scss">
.swiper-container-custom {
  /*max-width: 1000px;*/
  padding: 40px 0 30px;
  .swiper-wrapper {
    box-sizing: border-box;
    .swiper-slide {
      width: 200px;
      height: 200px;
      align-items: center;
      display: flex;
      border: 1px solid #ccc;
      padding: 0 10px;
    }
  }
  .swiper-button-prev, .swiper-button-next {
    top: 0;
  }
}

.file-input-contents {
  display: flex;
  flex-wrap: wrap;
  max-height: 600px;
  overflow-y: auto;
  &.with--padding {
    padding: 20px 30px 30px;
  }
}
.file-input-content {
  width: 200px;
  height: 150px;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px solid #ccc;
  padding: 0 10px;
  position: relative;
  margin: 5px;
}
.file-input__label {
  display: inline-block;
  padding: .5em .75em;
  color: #999;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #fdfdfd;
  cursor: pointer;
  border: 1px solid #ebebeb;
  border-bottom-color: #e2e2e2;
  border-radius: .25em;
}
.file-input__input {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip:rect(0,0,0,0);
  border: 0;
  &:before {
    content: none;
  }
}
.file-input-image {
  width: 100%;
  background: #ffffff;
  max-width: 200px;
  max-height: 190px;
  object-fit: scale-down;
}
.file-input__remove-button {
  z-index: 7;
  position: absolute;
  top: 5px;
  left: 5px;
}
</style>
